var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup313(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 40,
    viewBox: "0 0 96 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95.0033,
    height: 40,
    fill: "#D2000A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0589 31.5249L29.026 17.7154L22.2528 29.0918H19.8526L13.1122 18.0113V31.5249H8.11453V8.50912H12.5204L21.1349 22.8118L29.6179 8.50912H33.9909L34.0566 31.5249H29.0589Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6611 26.5929H44.9752L42.9367 31.5249H37.4787L47.7371 8.50912H52.9979L63.2892 31.5249H57.6997L55.6611 26.5929ZM53.9843 22.5487L50.3346 13.737L46.685 22.5487H53.9843Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3571 31.9195C75.0117 31.9195 72.8855 31.4153 70.9784 30.407C69.0933 29.3768 67.6028 27.9629 66.5068 26.1655C65.4327 24.3462 64.8957 22.2967 64.8957 20.017C64.8957 17.7374 65.4327 15.6988 66.5068 13.9014C67.6028 12.082 69.0933 10.6682 70.9784 9.65991C72.8855 8.62968 75.0226 8.11456 77.39 8.11456C79.3847 8.11456 81.1821 8.46528 82.7822 9.16671C84.4043 9.86815 85.7633 10.8765 86.8593 12.1916L83.4398 15.3481C81.8835 13.5507 79.9546 12.652 77.653 12.652C76.2282 12.652 74.9569 12.9698 73.839 13.6055C72.7211 14.2192 71.8443 15.0851 71.2086 16.203C70.5948 17.3209 70.288 18.5922 70.288 20.017C70.288 21.4418 70.5948 22.7131 71.2086 23.8311C71.8443 24.949 72.7211 25.8258 73.839 26.4614C74.9569 27.0752 76.2282 27.3821 77.653 27.3821C79.9546 27.3821 81.8835 26.4724 83.4398 24.653L86.8593 27.8095C85.7633 29.1466 84.4043 30.1659 82.7822 30.8673C81.1602 31.5687 79.3518 31.9195 77.3571 31.9195Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup313);
export default __webpack_public_path__ + "static/media/Group 313.a0771350490078bbe0110110b4c4bee8.svg";
export { ForwardRef as ReactComponent };